import styled from 'styled-components';

export const HeaderBtnContainer = styled.div`
    align-items: center;
    border: 2px solid rgb(255, 255, 255, 0.33);
    border-radius: 100px;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    gap: 8px;
    height: 44px;
    justify-content: center;
    padding: 0px 16px;
    transition: 0.4s;
    -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;

    h5 {
        color: #FFFFFF;
        font-size: 12px;
        font-weight: 600;
    }

    &:hover {
        transform: scale(1.05);
    }
`;
export const IconContainer = styled.div`
    align-items: center;
    display: flex;
    height: 16px;

    img {
        height: 100%;
    }
`;